export const signupUrl = process.env.REACT_APP_SIGNUP_URL;